<template>
	<div>
		<vs-popup class="holamundo" :title="$t('Harvest')" :active.sync="popupOrdersItems" fullscreen>
			<b-row>
				<OrdersItemsList :data="allProductList" :isSidebarActive="orderItemPopupActive"
					@closeSidebar="toggleDataSidebarItem" />
			</b-row>
		</vs-popup>

		<vs-card>
			<b-row>
				<h4 class="text-primary">
					{{ $t("CollectionCode") }} :
					{{ paramCollection }}
				</h4>
			</b-row>
			<vs-divider></vs-divider>
			<b-row align-h="start">
				<b-col cols="12" md="auto"><b-row>
						<b-col lg="4" style="text-align: start" align-self="center">
							<b-form-group style="font-size: medium" :label="'* ' + $t('Barcode')" label-for="h-first-name">
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label-for="item-name">
								<b-form-input id="barcodePackingId" ref="barcodePackingId" v-model="stockno"
									:placeholder="$t('Stockno')" @keyup.enter="filterOrderList" @input="stockNoValidate" />
							</b-form-group>
						</b-col>
					</b-row>
				</b-col>

				<b-col cols="12" md="auto">
					<b-row align-h="start">
						<b-col cols="3" md="auto">
							<b-button class="bg-danger" style="border-color: white" v-on:click="
								popupOrdersItems = true;
							toggleDataSidebarItem(true);
							">
								<Icon icon="fluent-mdl2:completed" width="20" height="20" />
								{{ $t("ProductItemList") }}
							</b-button>
						</b-col>
					</b-row>
				</b-col>
				<b-col lg="3">
					<b-row>
						<b-col lg="5" style="text-align: start" align-self="center">
							<b-form-group style="font-size: medium" :label="'* ' + $t('Quantity')" label-for="h-first-name">
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label-for="item-name">
								<b-form-input id="quantityManuel" ref="quantityManuel" v-model="quantityManuel"
									:placeholder="$t('Quantity')" v-validate="'required|decimal'" name="quantityManuel" />
								<span class="text-danger text-sm" v-if="errors.has('quantityManuel')">{{
									errors.first("quantityManuel")
								}}</span>
							</b-form-group>
						</b-col>
					</b-row>
				</b-col>
				<b-col cols="12" md="auto">
					<b-row align-h="start">
						<b-col cols="3" md="auto">
							<b-button class="bg-warning vs-con-loading__container" style="border-color: white" id="loading-pull-order"
								v-on:click="pullOrder()">
								<Icon icon="fluent-mdl2:completed" width="20" height="20" />
								{{ $t("PullOrder") }}
							</b-button>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
		</vs-card>

		<component :is="scrollbarTag" ref="scroll" class="vs-input--label scroll-area--data-list-add-new"
			:settings="settings" :key="$vs.rtl">
			<vs-card v-if="allOrdersScanned.length > 0">
				<b-row style="margin-left: 1px; margin-right: 1px">
					<b-col style="border: solid 0.1px; margin-bottom: 10px" cols="2" @click="
						tr.SectionOrderItemQuantity == tr.OrderItemReadQuantity
							? getOrderDetails(tr.SectionOrderNumber)
							: ''
						" :key="indextr" v-for="(tr, indextr) in allOrdersScanned">
						<b-row>
							<b-col cols="10">
								<h4>
									{{ $t("Division") }}: {{ tr.SectionNumber }} {{ tr.SectionOrderNumber }}
								</h4>
							</b-col>
							<b-col style="padding: 0px !important">
								<vs-chip :color="tr.SectionOrderItemQuantity == tr.OrderItemReadQuantity
										? 'success'
										: 'warning'
									">Sipariş Adedi: {{ tr.OrderItemReadQuantity }}
								</vs-chip>
								<vs-chip :color="tr.SectionOrderItemQuantity == tr.OrderItemReadQuantity
										? 'success'
										: 'warning'
									">Okunan Adet: {{ tr.SectionOrderItemQuantity }}
								</vs-chip>
							</b-col>
						</b-row>
					</b-col>
				</b-row>
			</vs-card>
		</component>
		<vs-popup class="holamundo" title="Sipariş Tamamla" :active.sync="popupOrderList" fullscreen @close="clearList"
			@cancel="clearList">
			<b-row>
				<b-col lg="6">
					<vs-card>
						<b-row align-h="start">
							<b-col cols="12" md="auto">
								<h5>{{ OrderNumber }}</h5>
								<vs-divider></vs-divider>
							</b-col>

							<b-col cols="12" md="auto">
								<b-button style="border-color: white; width: 100%" v-on:click="completeOrder()" id="button-with-loading"
									class="w-full vs-con-loading__container bg-danger">
									<Icon icon="ph:list-fill" style="margin-right: 5px" width="20" height="20" />{{ $t("CompleteOrder") }}
								</b-button>
							</b-col>
							<!--
              <b-col cols="12" md="auto">
                <b-button
                  style="border-color: white; width: 100%"
                  v-on:click="printBarcode()"
                  class="bg-warning"
                >
                  <Icon
                    icon="ph:list-fill"
                    style="margin-right: 5px"
                    width="20"
                    height="20"
                  />{{ $t("Print") }}
                </b-button>
              </b-col>-->
						</b-row>
					</vs-card>
					<vs-card>
						<b-row>
							<template lang="html">
								<!--
                <b-col style="margin-bottom: 8px" v-if="findedOrderItem.length > 1">
                  <b-form-input
                    v-model="barcodeDetailVal"
                    @keyup.enter="barcodeDetail()"
                    placeholder="Barkod Giriniz"
                    id="barkodR"
                  />
                </b-col>-->
								<vs-table v-model="selected" @selected="handleSelected" :data="findedOrderItem">
									<template slot="thead">
										<vs-th sort-key="OrderItemName">{{ $t("OrderItemName") }} </vs-th>
										<vs-th sort-key="OrderItemMarketPlaceCode">{{
											$t("OrderItemMarketPlaceCode")
										}}</vs-th>
										<vs-th sort-key="OrderItemBarcode">{{
											$t("OrderItemBarcode")
										}}</vs-th>
										<vs-th sort-key="OrderItemSellerCode">{{
											$t("OrderItemSellerCode")
										}}</vs-th>

										<vs-th sort-key="OrderItemQuantity">{{
											$t("OrderItemQuantity")
										}}</vs-th>
									</template>

									<template slot-scope="{ data }">
										<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
											<vs-td :data="data[indextr].OrderItemName">
												{{ data[indextr].OrderItemName }}
											</vs-td>
											<vs-td :data="data[indextr].OrderItemMarketPlaceCode">
												{{ data[indextr].OrderItemMarketPlaceCode }}
											</vs-td>
											<vs-td :data="data[indextr].OrderItemBarcode">
												{{ data[indextr].OrderItemBarcode }}
											</vs-td>
											<vs-td :data="data[indextr].OrderItemSellerCode">
												{{ data[indextr].OrderItemSellerCode }}
											</vs-td>

											<vs-td :data="data[indextr].OrderItemQuantity">
												{{ data[indextr].OrderItemQuantity }}
											</vs-td>
										</vs-tr>
									</template>
								</vs-table>
							</template>
						</b-row>
					</vs-card>
				</b-col>
				<b-col>
					<b-col>
						<div ref="printMeBarcode">
							<vs-card>
								<table class="custom-table">
									<tr>
										<th class="border-item" style="
                        padding: 12px;
                        border: 1px solid black;
                        border-radius: 5px;
                        font-size: 15px;
                        font-weight: bold;
                      ">
											{{ $t("invoiceNumber") }} :
										</th>
										<td class="border-item" style="
                        padding: 12px;
                        border: 1px solid black;
                        border-radius: 5px;
                        font-size: 15px;
                        font-weight: bold;
                      ">
											{{ invoiceNumber }}
										</td>
									</tr>
									<tr>
										<th class="border-item" style="
                        padding: 8px;
                        border: 1px solid black;
                        border-radius: 5px;
                        font-size: 15px;
                        font-weight: bold;
                      ">
											{{ $t("OrderSource") }} :
										</th>
										<td class="border-item" style="
                        padding: 8px;
                        border: 1px solid black;
                        border-radius: 5px;
                        font-size: 15px;
                        font-weight: bold;
                      ">
											{{ OrderSource }}
										</td>
									</tr>
									<tr>
										<th class="border-item" style="
                        padding: 8px;
                        border: 1px solid black;
                        border-radius: 5px;
                        font-size: 15px;
                        font-weight: bold;
                      ">
											{{ $t("OrderNumber") }} :
										</th>
										<td class="border-item" style="
                        padding: 8px;
                        border: 1px solid black;
                        border-radius: 5px;
                        font-size: 15px;
                        font-weight: bold;
                      ">
											{{ OrderNumber }}
										</td>
									</tr>
									<tr>
										<th class="border-item" style="
                        padding: 8px;
                        border: 1px solid black;
                        border-radius: 5px;
                        font-size: 15px;
                        font-weight: bold;
                      ">
											{{ $t("ShipmentName") }} :
										</th>
										<td class="border-item" style="
                        padding: 8px;
                        border: 1px solid black;
                        border-radius: 5px;
                        font-size: 15px;
                        font-weight: bold;
                      ">
											{{ ShipmentName }}
										</td>
									</tr>
									<tr>
										<th class="border-item" style="
                        padding: 8px;
                        border: 1px solid black;
                        border-radius: 5px;
                        font-size: 15px;
                        font-weight: bold;
                      ">
											{{ $t("ShipmentLastName") }} :
										</th>
										<td class="border-item" style="
                        padding: 8px;
                        border: 1px solid black;
                        border-radius: 5px;
                        font-size: 15px;
                        font-weight: bold;
                      ">
											{{ ShipmentLastName }}
										</td>
									</tr>

									<tr>
										<th class="border-item" style="
                        padding: 8px;
                        border: 1px solid black;
                        border-radius: 5px;
                        font-size: 15px;
                        font-weight: bold;
                      ">
											{{ $t("ShipmentAddress") }} :
										</th>
										<td class="border-item" style="
                        padding: 8px;
                        border: 1px solid black;
                        border-radius: 5px;
                        font-size: 15px;
                        font-weight: bold;
                      ">
											<h6 style="font-size: 15px">{{ ShipmentAddress }}</h6>
										</td>
									</tr>
									<tr>
										<th class="border-item" style="
                        padding: 8px;
                        border: 1px solid black;
                        border-radius: 5px;
                        font-size: 15px;
                        font-weight: bold;
                      ">
											{{ $t("OrderCargoName") }} :
										</th>
										<td class="border-item" style="
                        padding: 8px;
                        border: 1px solid black;
                        border-radius: 5px;
                        font-size: 15px;
                        font-weight: bold;
                      ">
											<h6 style="font-size: 15px">{{ OrderCargoName }}</h6>
										</td>
									</tr>
									<tr>
										<th class="border-item" style="
                        padding: 8px;
                        border: 1px solid black;
                        border-radius: 5px;
                        font-size: 15px;
                        font-weight: bold;
                      ">
											{{ $t("OrderDate") }} :
										</th>
										<td class="border-item" style="
                        padding: 8px;
                        border: 1px solid black;
                        border-radius: 5px;
                        font-size: 15px;
                        font-weight: bold;
                      ">
											<h6 style="font-size: 15px">{{ OrderDate }}</h6>
										</td>
									</tr>
									<tr>
										<th class="border-item" style="
                        padding: 8px;
                        border: 1px solid black;
                        border-radius: 5px;
                        font-size: 15px;
                        font-weight: bold;
                      ">
											{{ $t("OrderBarcodes") }} :
										</th>
										<td class="border-item" style="
                        padding: 8px;
                        border: 1px solid black;
                        border-radius: 5px;
                        font-size: 15px;
                        font-weight: bold;
                      ">
											<h6 style="font-size: 15px">{{ OrderBarcodes }}</h6>
										</td>
									</tr>
									<tr>
										<th class="border-item" style="
                        padding: 8px;
                        border: 1px solid black;
                        border-radius: 5px;
                        font-size: 15px;
                        font-weight: bold;
                      ">
											{{ $t("OrderCargoNumber") }} :
										</th>
										<td class="border-item" style="
                        padding: 8px;
                        border: 1px solid black;
                        border-radius: 5px;
                        font-size: 15px;
                        font-weight: bold;
                      ">
											<h6 style="font-size: 15px">{{ OrderCargoNumber }}</h6>
										</td>
									</tr>
									<tr>
										<th class="border-item" style="
                        padding: 8px;
                        border: 1px solid black;
                        border-radius: 5px;
                        font-size: 15px;
                        font-weight: bold;
                      ">
											{{ $t("TotalPrice") }} :
										</th>
										<td class="border-item" style="
                        padding: 8px;
                        border: 1px solid black;
                        border-radius: 5px;
                        font-size: 15px;
                        font-weight: bold;
                      ">
											<h6 style="font-size: 15px">{{ TotalPrice }}</h6>
										</td>
									</tr>

									<tr v-if="OrderCargoNumber" style="margin-top: 150px">
										<td class="border-item barcode-container" colspan="2">
											<div style="width: 100%; height: auto">
												<barcode :value="OrderCargoNumber" format="CODE128" tag="svg" :width="4" :height="150"
													:text-options="{ fontSize: 1000 }" style="width: 100%; height: auto" />
											</div>
										</td>
									</tr>
								</table>
							</vs-card>
						</div>
					</b-col>
				</b-col>
			</b-row>
			<vs-prompt :title="$t('Submit')" :acceptText="$t('Save')" :cancelText="$t('Cancel')" @accept="ordersToInvoice"
				@cancel="toInvoiceCancel" @close="toInvoiceCancel" :active.sync="activePromptToInvoice">
				<div class="con-exemple-prompt">
					<b-row style="align-items: center">
						<b-col lg="12">
							<span>{{ $t("ConfirmToInvoiceInfo") }} {{ $t("AreYSure") }}
								{{ $t("CantUndo") }}</span>
						</b-col>
					</b-row>
				</div>
			</vs-prompt>
		</vs-popup>
	</div>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { Icon } from "@iconify/vue2";
import OrdersItemsList from "./OrdersItemsList.vue";
import Barcode from "vue-barcode";
export default {
	components: {
		Barcode,
		Icon,
		VuePerfectScrollbar,
		OrdersItemsList,
	},
	data() {
		return {
			activePromptToInvoice: false,
			quantityManuel: 1,
			OrderCargoNumber: "",
			TotalPrice: "",
			OrderDate: "",
			OrderCargoName: "",
			InvoiceAddress: "",
			InvoiceLastName: "",
			InvoiceName: "",

			ShipmentName: "",
			ShipmentLastName: "",
			ShipmentAddress: "",
			ShipmentCity: "",
			ShipmentDistirct: "",

			OrderSource: "",
			invoiceNumber: "",
			OrderBarcodes: "",
			popupOrderList: false,
			allOrdersScanned: [],
			orderItems: [],
			popupOrdersItems: false,
			orderItemPopupActive: false,
			completeOrderValidate: true,
			findedOrderTotalQty: 0.0,
			findedOrderTotalAdded: 0.0,
			OrderNumber: "",
			CollectionCode: "",
			CompanyName: "",
			submitDataValidate: false,
			stockno: "",
			selected: [],
			findedOrderItem: [],
			allProductList: [],
			paramCollection: "",
			paramMarketplace: "",
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			orderDetailList: [],
			barcodeDetailVal: "",
		};
	},
	methods: {
		stockNoValidate() {
			this.stockno = this.stockno.replace(/\?/g, "_").replace(/ı/g, "i");
		},
		toInvoiceCancel() {
			var vs = this.$vs;
			setTimeout(() => {
				vs.loading.close("#button-with-loading > .con-vs-loading");
			}, 1000);
		},
		printBarcode() {
			const printContents = this.$refs.printMeBarcode.innerHTML;
			const originalContents = document.body.innerHTML;

			const printWindow = window.open("", "", "height=600,width=800");
			printWindow.document.write("<html><head><title>Print</title>");
			printWindow.document.write("</head><body >");
			printWindow.document.write(printContents);
			printWindow.document.write("</body></html>");
			printWindow.document.close();
			printWindow.print();
			this.toggleDataSidebarItem(false);
		},
		ordersToInvoice() {
			this.completeOrderValidate = true;
			var vs = this.$vs;
			let selectedOrderList = [];
			let deger = this.orderDetailList;
			selectedOrderList.push({
				companyId: deger.CompanyId,
				companyInfoId: deger.CompanyInfoId,
				//     depotId: deger.DepotId == null ? this.storehouse.value : deger.DepotId,
				orderNumber: deger.OrderNumber,
				orderDate: deger.OrderDate,
				orderId: deger.OrderId,
				orderStatus: deger.OrderStatus,
				orderPymentType: deger.OrderPymentType == null ? "" : deger.OrderPymentType,
				orderSource: deger.OrderSource,
				orderCargoName: deger.OrderCargoName,
				orderCargoNumber: deger.OrderCargoNumber,
				orderCurrency: deger.OrderCurrency,
				orderWarehouseId: deger.OrderWarehouseId,
				shipmentName: deger.ShipmentName,
				shipmentLastName: deger.ShipmentLastName,
				shipmentAddress: deger.ShipmentAddress,
				shipmentPostalCode:
					deger.ShipmentPostalCode == null ? "" : deger.ShipmentPostalCode,
				shipmentCity: deger.ShipmentCity,
				shipmentCityCode: deger.ShipmentCityCode,
				shipmentDistirct: deger.ShipmentDistirct,
				shipmentIdentityNumber:
					deger.ShipmentIdentityNumber == null ? "" : deger.ShipmentIdentityNumber,
				shipmentPhone: deger.ShipmentPhone == null ? "" : deger.ShipmentPhone,
				shipmentMail: deger.ShipmentMail == null ? "" : deger.ShipmentMail,
				invoiceCompany: deger.InvoiceCompany,
				invoiceName: deger.InvoiceName,
				invoiceLastName: deger.InvoiceLastName,
				invoiceAddress: deger.InvoiceAddress,
				invoicePostalCode: deger.InvoicePostalCode == null ? "" : deger.InvoicePostalCode,
				invoiceCity: deger.InvoiceCity,
				invoiceCityCode: deger.InvoiceCityCode == null ? "" : deger.InvoiceCityCode,
				invoiceDistirct: deger.InvoiceDistirct == null ? "" : deger.InvoiceDistirct,
				invoiceIdentityNumber:
					deger.InvoiceIdentityNumber == null ? "" : deger.InvoiceIdentityNumber,
				invoicePhone: deger.InvoicePhone == null ? "" : deger.InvoicePhone,
				invoiceMail: deger.InvoiceMail == null ? "" : deger.InvoiceMail,
				invoiceTaxOffice: deger.InvoiceTaxOffice,
				invoiceTaxNumber: deger.InvoiceTaxNumber,
				customerId: deger.CustomerId,
				customer: deger.Customer,
				customerMail: deger.CustomerMail,
				customerPhone: deger.CustomerPhone == null ? "" : deger.CustomerPhone,
				totalPrice: deger.TotalPrice,
				orderNote: "",
				items: [],
			});
			deger.Items.forEach((selectedItem, selectedItemIndex) => {
				selectedOrderList[0].items.push({
					orderItemId: selectedItem.OrderItemId,
					orderItemName: selectedItem.OrderItemName,
					orderItemSellerCode: selectedItem.OrderItemSellerCode,
					orderItemMarketPlaceCode: selectedItem.OrderItemMarketPlaceCode,
					orderItemBarcode: selectedItem.OrderItemBarcode,
					orderItemVatRate: selectedItem.OrderItemVatRate,
					orderItemQuantity: selectedItem.OrderItemQuantity,
					orderItemPrice: selectedItem.OrderItemPrice,
					orderItemDiscount: selectedItem.OrderItemDiscount,
				});
			});
			this.ordersForInvoice = {
				totalItem: 0,
				totalPage: 0,
				page: 0,
				orders: selectedOrderList,
			};
		/*	if (activeUserInfo.earchiveuse == "False") {
				setTimeout(() => {
					this.printBarcode();
				}, 1000);
				setTimeout(() => {
					this.getOrderCollectList();
					this.getOrderCollectItemList();
				}, 1500);
			}
			else {*/
				this.$store
					.dispatch("order/sendOrderToArchive", this.ordersForInvoice)
					.then((response) => {
						if (response.success == true) {
							vs.notify({
								text: response.message,
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "success",
								position: "top-center",
							});
							try {
								let invoiceJson = JSON.parse(response.json);
								this.invoiceNumber = invoiceJson.InvoiceId;
								//  this.clearList();
								setTimeout(() => {
									this.printBarcode();
								}, 1000);
								setTimeout(() => {
									this.getOrderCollectList();
									this.getOrderCollectItemList();
								}, 1500);
							} catch (error) {
								console.log(error);
							}

							setTimeout(() => {
								vs.loading.close("#button-with-loading > .con-vs-loading");
							}, 1000);
						} else {
							this.completeOrderValidate = false;
							setTimeout(() => {
								vs.loading.close("#button-with-loading > .con-vs-loading");
							}, 1000);
							vs.notify({
								text: response.data.message.toString(),
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "danger",
								position: "top-center",
							});
						}
					})
					.catch((error) => {
						this.completeOrderValidate = false;
						setTimeout(() => {
							vs.loading.close("#button-with-loading > .con-vs-loading");
						}, 1000);
						vs.notify({
							text: error.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});
					});
		//	}

		},
		barcodeDetail() {
			const vs = this.$vs;
			let findedData = this.findedOrderItem.find(
				(item) => item.OrderItemBarcode === this.barcodeDetailVal
			);
			if (findedData) {
				let index = this.findedOrderItem.indexOf(findedData);
				if (this.findedOrderItem[index].orderItemRead == 0) {
					this.findedOrderItem[index].orderItemRead = 1;
				} else {
					if (
						this.findedOrderItem[index].OrderItemQuantity <=
						this.findedOrderItem[index].orderItemRead
					) {
						vs.notify({
							text: "Okutulan adet sipariş adedinden büyük olamaz.",
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "warning",
							position: "top-center",
						});
					} else {
						this.findedOrderItem[index].orderItemRead =
							this.findedOrderItem[index].orderItemRead + 1;
					}
				}
			} else {
				vs.notify({
					text: "Barkod listede bulunmuyor.",
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "warning",
					position: "top-center",
				});
			}
			let orderTotal = 0,
				orderItemReadTotal = 0;
			this.findedOrderItem.forEach((val, index) => {
				orderTotal += val.OrderItemQuantity;
				orderItemReadTotal += val.orderItemRead;
			});
			if (orderTotal == orderItemReadTotal) this.completeOrderValidate = false;

			this.barcodeDetailVal = "";
			document.getElementById("barkodR").focus();
		},
		setDetails() {
			this.OrderBarcodes = "";
			console.log(this.orderDetailList)
			this.findedOrderItem = this.orderDetailList.Items;
			for (let index = 0; index < this.findedOrderItem.length; index++) {
				this.findedOrderItem[index].orderItemRead = 0;
				this.OrderBarcodes +=
					this.findedOrderItem[index].OrderItemBarcode +
					"(" +
					this.findedOrderItem[index].OrderItemQuantity +
					" adet) ";
			}
			this.OrderNumber = this.orderDetailList.OrderNumber;
			this.OrderCargoName = this.orderDetailList.OrderCargoName;
			this.OrderCargoNumber = this.orderDetailList.OrderCargoNumber;
			this.InvoiceName = this.orderDetailList.InvoiceName;
			this.InvoiceLastName = this.orderDetailList.InvoiceLastName;
			this.InvoiceAddress = this.orderDetailList.InvoiceAddress;
			this.InvoiceCity = this.orderDetailList.InvoiceCity;
			this.InvoiceDistirct = this.orderDetailList.InvoiceDistirct;

			this.ShipmentName = this.orderDetailList.ShipmentName;
			this.ShipmentLastName = this.orderDetailList.ShipmentLastName;
			this.ShipmentAddress = this.orderDetailList.ShipmentAddress;
			this.ShipmentCity = this.orderDetailList.ShipmentCity;
			this.ShipmentDistirct = this.orderDetailList.ShipmentDistirct;

			this.OrderSource = this.orderDetailList.OrderSource;
			this.OrderDate = this.orderDetailList.OrderDate;
			this.TotalPrice = this.orderDetailList.TotalPrice;
		},
		getOrderDetails(orderNumber, isList) {
			const vm = this;
			vm.popupOrderList = true;
			vm.completeOrderValidate = true;
			vm.OrderNumber = orderNumber;
			if (isList == true) {
				this.setDetails();
			} else {
				this.$store
					.dispatch("order/listOrderToOrderNumber", orderNumber)
					.then((response) => {
						if (response.success == true) {
							let orderReaded = JSON.parse(response.json);
							this.orderDetailList = orderReaded[0];
							this.setDetails();
						} else {
							vs.notify({
								text: response.message.toString(),
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "danger",
								position: "top-center",
							});
						}
					})
					.catch((error) => {
						return new Promise((resolve, reject) => {
							resolve(false);
						});
					});
			}
		},
		toggleDataSidebarItem(val = false) {
			this.orderItemPopupActive = val;
		},
		clearList() {
			this.barcode = "";
			this.OrderNumber = "";
			this.OrderCargoName = "";
			this.OrderCargoNumber = "";
			this.InvoiceName = "";
			this.InvoiceLastName = "";
			this.InvoiceAddress = "";
			this.InvoiceCity = "";
			this.InvoiceDistirct = "";

			this.ShipmentName = "";
			this.ShipmentLastName = "";
			this.ShipmentAddress = "";
			this.ShipmentCity = "";
			this.ShipmentDistirct = "";


			this.OrderSource = "";
			this.OrderDate = "";
			this.TotalPrice = "";
			this.OrderBarcodes = "";
			//    this.selectedOrdersItems = [];
			this.findedOrderItem = [];
			this.completeOrderValidate = true;
			this.findedOrderTotalQty = 0.0;
			this.findedOrderTotalAdded = 0.0;
			var vs = this.$vs;
			setTimeout(() => {
				vs.loading.close("#button-with-loading > .con-vs-loading");
			}, 1000);
		},
		completeOrder() {
			var vs = this.$vs;
			setTimeout(() => {
				vs.loading({
					container: "#button-with-loading",
					scale: 0.45,
				});
			}, 1000);

			this.activePromptToInvoice = true;
		},
		submitData() {
			var vs = this.$vs;
		},

		filterOrderList() {
			var vs = this.$vs;

			let obj = {
				sectioncode: this.paramCollection,
				barcode: this.stockno,
				quantity: this.quantityManuel
			};

			this.$store
				.dispatch("order/listOrderPackageControl", obj)
				.then((response) => {
					if (response.success == true) {
						let orderReaded = JSON.parse(response.json);
						if (orderReaded.totalItem <= 1) {
							this.orderDetailList = orderReaded.order;
							this.getOrderDetails(orderReaded.order.OrderNumber, true);
						} else this.getOrderCollectList();
						this.stockno = "";
						setTimeout(() => {
							document.getElementById("barcodePackingId").focus();
						}, 1000);
					} else {
						if (
							response.data.message.toString().includes("Order item quantity read done")
						) {
							vs.notify({
								text: response.data.message.toString(),
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "warning",
								position: "top-center",
							});
							this.stockno = "";
						}
					}
				})
				.catch((error) => {
					vs.notify({
						text: error.toString(),
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center",
					});
				});
		},
		pullOrder() {
			let type = "material";
			var vs = this.$vs;
			vs.loading({
				container: `#loading-pull-order`,
				type,
				scale: 0.75,
			});
			let obj = { companyInfoId: this.paramMarketplace };
			this.$store
				.dispatch("order/pullOrder", obj)
				.then((response) => {
					setTimeout(() => {
						vs.loading.close("#loading-pull-order > .con-vs-loading");
					}, 1000);
					if (response.success == true) {
						this.getOrderCollectList();
						this.getOrderCollectItemList();
						vs.notify({
							text: response.message.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "success",
							position: "top-center",
						});
					} else {
						vs.notify({
							text: response.message.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});
					}
				})
				.catch((error) => {
					setTimeout(() => {
						vs.loading.close("#loading-pull-order > .con-vs-loading");
					}, 1000);
					vs.notify({
						text: error.toString(),
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center",
					});
				});
		},
		handleSelected(tr) { },
		getOrderCollectItemList() {
			try {
				this.allProductList = [];
				var vs = this.$vs;
				this.$store
					.dispatch("order/listOrderCollectControl", this.paramCollection) //listOrderCollectControl
					.then((response) => {
						if (response.success == true) {
							try {
								let allProductListLc = JSON.parse(response.json);
								allProductListLc.forEach((value, index) => {
									value.Items.forEach((val, ind) => {
										this.allProductList.push({
											OrderNumber: value.OrderNumber,
											OrderCargoName: value.OrderCargoName,
											OrderCargoNumber: value.OrderCargoNumber,
											CompanyId: value.CompanyId,
											CompanyInfoId: value.CompanyInfoId,
											Customer: value.Customer,
											CustomerId: value.CustomerId,
											CustomerMail: value.CustomerMail,
											CustomerPhone: value.CustomerPhone,
											DepotId: value.DepotId,
											InvoiceAddress: value.InvoiceAddress,
											InvoiceCity: value.InvoiceCity,
											InvoiceCityCode: value.InvoiceCityCode,
											InvoiceCompany: value.InvoiceCompany,
											InvoiceDistirct: value.InvoiceDistirct,
											InvoiceIdentityNumber: value.InvoiceIdentityNumber,
											InvoiceLastName: value.InvoiceLastName,
											InvoiceMail: value.InvoiceMail,
											InvoiceName: value.InvoiceName,
											InvoicePhone: value.InvoicePhone,
											InvoicePostalCode: value.InvoicePostalCode,
											InvoiceTaxNumber: value.InvoiceTaxNumber,
											InvoiceTaxOffice: value.InvoiceTaxOffice,
											OrderItemBarcode: val.OrderItemBarcode,
											OrderItemDiscount: val.OrderItemDiscount,
											OrderItemId: val.OrderItemId,
											OrderItemMarketPlaceCode: val.OrderItemMarketPlaceCode,
											OrderItemName: val.OrderItemName,
											OrderItemPrice: val.OrderItemPrice,
											OrderItemQuantity: val.OrderItemQuantity,
											OrderItemSellerCode: val.OrderItemSellerCode,
											OrderItemVatRate: val.OrderItemVatRate,
										});
									});
								});
								this.CollectionCode = this.allProductList[0].CollectionCode;
								this.CompanyName = this.allProductList[0].CompanyName;
							} catch (error) {
								console.log(error);
							}
						} else {
						}
					})
					.catch((error) => {
						console.log(error);
						vs.notify({
							text: error.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});
					});
			} catch (error) {
				console.log(error);
			}
		},
		getOrderCollectList() {
			var vs = this.$vs;
			console.log(this.paramCollection)
			try {
				this.$store
					.dispatch("order/listOrderPackageScanned", this.paramCollection)
					.then((response) => {
						if (response.success == true) {
							try {
								this.allOrdersScanned = JSON.parse(response.json);
							} catch (error) {
								console.log(error);
							}
						} /*else

              vs.notify({
                text: response.data.message.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });*/
					})
					.catch((error) => {
						console.log(error);
						return new Promise((resolve, reject) => {
							resolve(false);
						});
					});
			} catch (error) {
				console.log(error);
			}
		},
		cacheOrder() {
			var vs = this.$vs;
			try {
				this.$store
					.dispatch("order/cacheOrder")
					.then((response) => {
						if (response.success == true) {
							try {
								console.log(JSON.parse(response.json));
							} catch (error) {
								console.log(error);
							}
						} /*else

              vs.notify({
                text: response.data.message.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });*/
					})
					.catch((error) => {
						console.log(error);
						return new Promise((resolve, reject) => {
							resolve(false);
						});
					});
			} catch (error) {
				console.log(error);
			}
		},
	},
	created() {
		// URL: /inventory-movements?productId=45&type=entry
		// URL: /inventory-movements/45
		this.paramCollection = this.$route.params.collection;
		this.paramMarketplace = this.$route.params.marketplace;
		// this.cacheOrder();
		this.getOrderCollectList();
		this.getOrderCollectItemList();

		setTimeout(() => {
			document.getElementById("barcodePackingId").focus();
		}, 1000);
	},
	computed: {
		activeUserInfo() {
			return this.$store.state.AppActiveUser;
		},
		scrollbarTag() {
			return this.$store.getters.scrollbarTag;
		},
	},
	mounted() {
		setTimeout(() => {
			this.$refs.barcodePackingId.focus();
		}, 1000);
	},
};
</script>
<style lang="scss" scoped>
.scroll-area--data-list-add-new {
	// height: calc(var(--vh, 1vh) * 100 - 4.3rem);
	height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 110px);

	&:not(.ps) {
		overflow-y: auto;
	}
}

.con-vs-dialog {
	z-index: 520055;
}
</style>
